module.exports = __webpack_public_path__ + "img/paris-hilton-2025-2.2516389e.webp";